import * as API_CONSTANT from '../constants'

export const getRuleInfoByRULEID = (ruleid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            ruleid
        })
    })
    .then(res => res.json())
)

export const getRuleInfoBatch = (ruleids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/batch/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            ruleids
        })
    })
    .then(res => res.json())
)

export const getRuleTemplateByRULETID  = (ruletid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/getTemplate`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            ruletid
        })
    })
    .then(res => res.json())
)

export const getRuleTemplateBatch = (ruletids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/batch/getTemplate`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            ruletids
        })
    })
    .then(res => res.json())
)

export const createRuleT = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getRuleParam = () => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/param/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({})
    })
    .then(res => res.json())
)

export const createRuleTemplate = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/ruleTemplate/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const updateRuleTemplate = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/ruleTemplate/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const createRule = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const updateRule = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/rule/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const deleteRuleTemplate = (ruletid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/ruleTemplate/delete`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            ruletid
        })
    })
    .then(res => res.json())
)